$(document).ready(function() {
  var pickupLabel = "Pick-Up at Ottawa Rideau Ctr Store?"; // the text of the label
  var buttonArea = $('.cart .cart__additional_checkout'); // where to insert the option
  var pickupVariantIdRideau = 32888708005972; // the variant ID of the local pickup product

  Shopify.getCart(function(cart) {
    var inCartRideau = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == pickupVariantIdRideau) {
        inCartRideau = true;
        return false;
      }
    });
    buttonArea.append('<div style="text-align: left; margin-top: 15px;"><label for="local-pickup-rideau" style="padding: 5px; border: 1px solid #000; "><input id="local-pickup-rideau" type="checkbox"' + (inCartRideau ? ' checked' : '') + ' /> ' + pickupLabel + '</label></div>');
  });

  buttonArea.on('change', '#local-pickup-rideau', function() {
    if ($(this).is(':checked')) {
      Shopify.addItem(pickupVariantIdRideau, 1, function(item) {
        location.reload();
      });
    } else {
      Shopify.changeItem(pickupVariantIdRideau, 0, function(cart) {
        location.reload();
      });
    }
  });

});